export default {
  GET_CODE: '/auth/public/emailLog/getDeregistrationCode',
  CONFIRM_CODE: '/auth/user/confirmDeregistration'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/myProfile.js